// Centralized Changelog & Version Data Source
// The Footer component reads the first item in this array to display the latest stable release version.
import { useEffect, useState } from 'react';
import { db } from '../firebase/firebaseConfig';
import { ref, onValue } from 'firebase/database';
import { useLocation } from 'react-router-dom';

export const changelogUpdates = [
  // {
  //   type: 'major',
  //   version: "v4.5.1",
  //   date: "28 March 2026",
  //   title: "Admin Security Dashboard",
  //   description: "Launched a new security dashboard for administrators to monitor platform activity and user data securely.",
  //   points: [
  //     "Added a new Security Dashboard for administrators.",
  //     "Added a Live Feed to monitor system activity in real-time.",
  //     "Improved the layout to look better on high-resolution displays.",
  //     "Standardized user identity tracking across the platform."
  //   ],
  //   category: "Security & UI"
  // },
  // {
  //   type: 'major',
  //   version: "v4.4.0",
  //   date: "28 March 2026",
  //   title: "Enhanced Security & 2FA",
  //   description: "Added new layers of security including email validation and Two-Factor Authentication (2FA) via BharatVerify.",
  //   points: [
  //     "Added mandatory Email Verification for all new accounts.",
  //     "Added BharatVerify Two-Factor Authentication (2FA) for extra security.",
  //     "Improved the Admin search tool to easily find users.",
  //     "Added a Password Reset feature for users who forget their passwords."
  //   ],
  //   category: "Security & Auth"
  // },
  {
    type: 'warning',
    version: "v4.3.1",
    date: "27 March 2026",
    title: "System Alerts Update",
    description: "Added a new popup alert system on the homepage to keep users informed about maintenance and updates.",
    points: [
      "Added a homepage System Alert popup for important announcements.",
      "Updated system broadcast icons to be clearer.",
      "Added notices about the AI Assistant currently being under development.",
      "Ensured the alert popup stays closed once you acknowledge it."
    ],
    category: "Communication & UX",
    status: "Stable"
  },
  {
    type: 'warning',
    version: "v4.3.0",
    date: "27 March 2026",
    title: "Security Patch & AI Update",
    description: "Deployed a new security patch to protect user data and temporarily paused some AI features for improvements.",
    points: [
      "Deployed Security Patch 4.3.0 to protect user profiles.",
      "Placed the AI Assistant and Resume Builder into 'Maintenance Mode'.",
      "Improved how the system extracts names and emails.",
      "Made sure admins don't see public system broadcasts unnecessarily."
    ],
    category: "Security & AI",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v4.0.0",
    date: "27 March 2026",
    title: "Legal & Documentation Rewrite",
    description: "Completely rewrote our documentation and legal pages to be much easier to read and understand.",
    points: [
      "Rewrote the Documentation page using simple, plain English.",
      "Updated the Privacy Policy and Terms of Service to remove confusing jargon.",
      "Redesigned the About page to clearly explain what DevTracker does.",
      "Fixed a bug where the sidebar menu wasn't displaying correctly."
    ],
    category: "Platform",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v3.5.0",
    date: "26 March 2026",
    title: "Admin Moderation Tools",
    description: "Added new tools for administrators to help moderate users and keep the platform safe.",
    points: [
      "Added the ability for admins to view user details quickly.",
      "Added tools to warn, suspend, or ban accounts that break the rules.",
      "Fixed some missing links in user profiles."
    ],
    category: "Security",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.6.9.6",
    date: "27 March 2026",
    title: "Zenith Sentinel Upgrade",
    description: "Final architectural evolution of the SOC with holographic threat mapping and reactive diagnostics.",
    points: [
      "Deployed the SEC-V2.6.9.6-ULTRA baseline with holographic 'Global Threat Map' diagnostics.",
      "Implemented 'System Heartbeat' reactive waveform for real-time synchronicity tracking.",
      "Patched Kernel L4 Logic: Resolved 'get' definition error in the cross-vector audit engine.",
      "Intensified Zenith CRT-Phosphor optics with advanced glassmorphic depth and pulsing nodes."
    ],
    category: "Security",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.6.9.4",
    date: "27 March 2026",
    title: "Smart Security Queue Overhaul",
    description: "Transformation of the security review layer into a high-fidelity incident management suite.",
    points: [
      "Overhauled Security Review Queue with a 'Smart Incident' card-based grid layout.",
      "Implemented glowing neon threat indicators (Critical/High/Medium) for rapid triage.",
      "Integrated a direct 'Research ID' link to the Target Identity Intelligence portal.",
      "Added real-time light-sweep glare animations and glassmorphic depth to incident cards."
    ],
    category: "Security",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.6.9.3",
    date: "27 March 2026",
    title: "NSS-V1.x Core Upgrade",
    description: "Pro-grade UI/UX refinement of the System Security Matrix with advanced scanning optics.",
    points: [
      "Launched the NSS-V1.0.9.27 Core with pro-grade versioning and SOC command center upgrades.",
      "Implemented a dynamic scanning grid background and animated horizon scan-line effect.",
      "Enhanced glowing neon borders and intensified glassmorphic panel optics.",
      "Optimized integrity gauge typography for pro-grade governance precision."
    ],
    category: "Security",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.6.9.1",
    date: "27 March 2026",
    title: "Intelligence & Docs Synchronization",
    description: "Multi-system synchronization of platform documentation handles and universal search resilience.",
    points: [
      "Hardened Target Identity Search with prioritized direct UID lookups and resilient query fallbacks.",
      "Migrated Security Review Log to live Firebase persistence for permanent audit accuracy.",
      "Populated production registry with missing identities for 100% search resolution.",
      "Synchronized Administrator Handbook with System Security and Identity Intelligence guides."
    ],
    category: "Security",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.6.8",
    date: "27 March 2026",
    title: "Target Identity Intelligence System",
    description: "Launch of the universal search portal for administrators, providing 360-degree visibility into any platform identity.",
    points: [
      "Implemented a universal search engine resolving SUID, UID, and Username identifiers.",
      "Designed a comprehensive 'User Profile' aggregating technical and governance data.",
      "Integrated automated cross-referencing for linked Reports and Cases.",
      "Included dynamic Trust Score Score visualization for account safety audits.",
      "Updated platform security badge to SEC-v2.6.6-ORIGIN."
    ],
    category: "Security",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.6.7",
    date: "27 March 2026",
    title: "Broadcast Attribution & Accountability",
    description: "Enhanced the Broadcast Center with explicit administrator attribution and AI-assisted content indicators.",
    points: [
      "Implemented senderName and attribution tracking in the notification engine.",
      "Refined Sent History UI to display administrator names and unique IDs.",
      "Added 'AI Assisted' badges for notifications drafted using the AI generator.",
      "Synchronized audit logging with the new attribution metadata.",
      "Updated platform security badge to SEC-v2.6.7-ORIGIN."
    ],
    category: "Communication",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.6.5",
    date: "27 March 2026",
    title: "System Security Audit System",
    description: "Launch of the proactive diagnostic scanner within the Security Review portal, enabling real-time system-wide integrity checks.",
    points: [
      "Implemented runSecurityAudit engine for multi-phase diagnostic scanning.",
      "Designed a terminal-style log console for real-time diagnostic feedback.",
      "Integrated glassmorphic progress tracking with neon-intensity status gradients.",
      "Added integrity checks for legal versioning, suspension sync, and log continuity.",
      "Optimized AdminSecurityReview aesthetics with immersive system detailing."
    ],
    category: "Security",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.6.4",
    date: "27 March 2026",
    title: "Banner Content Synchronization",
    description: "Launch of the synchronized notification banner, highlighting the v2.6.x stabilization milestones.",
    points: [
      "Updated SystemUpdateBanner.jsx with contextual highlights for Footer Revitalization and Legal Sync.",
      "Synchronized banner status to STABILIZATION mode for v2.6.x series.",
      "Ensured that latestVersion hooks are correctly propagated to the primary notification layer.",
      "Updated platform security badge to SEC-v2.6.4-ORIGIN.",
      "Finalized cross-platform header synchronization for the March 27 release cycle."
    ],
    category: "Communication",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.6.3",
    date: "27 March 2026",
    title: "Legal Version Synchronization",
    description: "Architectural automation of legal documentation versioning using platform-wide hooks.",
    points: [
      "Integrated `useLatestVersion` hook into PrivacyPolicy.jsx for dynamic versioning.",
      "Integrated `useLatestVersion` hook into Terms.jsx for dynamic versioning.",
      "Ensured legal version headers (Policy/Standard) are permanently synchronized with the root website version.",
      "Removed legacy hardcoded version strings from the platform's legal governance layer.",
      "Finalized the v2.6.x stabilization cycle with synchronized cross-platform headers."
    ],
    category: "Architecture",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.6.2",
    date: "27 March 2026",
    title: "Legal Content Synchronicity",
    description: "Policy and operational terms refresh to ensure platform governance is aligned with the latest v2.6.x architectural releases.",
    points: [
      "Synchronized PrivacyPolicy.jsx version to Policy v2.6.2 (March 27, 2026).",
      "Synchronized Terms.jsx version to Standard v2.6.2 (March 27, 2026).",
      "Ensured legal transparency regarding system DNA scoring and data ingestion protocols.",
      "Audited internal legal routes for architectural consistency and professional clarity.",
      "Synchronized all platform headers to the current v2.6.2 baseline."
    ],
    category: "Governance",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.6.1",
    date: "27 March 2026",
    title: "Footer Aesthetic Revitalization",
    description: "Launch of the high-fidelity connectivity footer, featuring iconic parity for Developer and Legal sections.",
    points: [
      "Refactored Footer.jsx to eliminate legacy inline styles and migrate to a CSS-driven architecture.",
      "Integrated high-fidelity icons for the Legal section (Shield & Contract) for professional clarity.",
      "Designed premium social connectivity nodes with brand-specific hover transitions (GitHub, Twitter, LinkedIn).",
      "Added glassmorphic detailing to the platform version and UTC timestamp nodes.",
      "Optimized footer-grid spacing for enhanced visual hierarchy and mobile responsiveness."
    ],
    category: "Design",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.6.0",
    date: "27 March 2026",
    title: "Version Routing Standardization",
    description: "Architectural routing refinement resolving platform-wide 404 entrance issues and providing context-aware version redirects.",
    points: [
      "Standardized 'What's New' routing to a segment-based /whats-new/:version architecture.",
      "Resolved 404 errors triggered by unconventional hyphenated parameter matching.",
      "Synchronized SystemUpdateBanner.jsx with standardized architectural links.",
      "Implemented deep-linking for Homepage 'What's New' cards to specific version landing pages.",
      "Hardened navigational paths across the external and administrative platform layers."
    ],
    category: "Architecture",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.5.9",
    date: "27 March 2026",
    title: "Homepage 'What's New' Integration",
    description: "Launch of the dynamic evolution section on the landing page, showcasing real-time platform updates.",
    points: [
      "Integrated 'What's New' grid on the homepage using live changelog nodes.",
      "Designed premium glassmorphic cards with version-specific metadata.",
      "Added interactive navigational links to the centralized Chronology portal.",
      "Implemented responsive card layouts for optimal mobile/desktop presentation.",
      "Synchronized homepage awareness with the latest security and feature releases."
    ],
    category: "Engagement",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.5.8",
    date: "27 March 2026",
    title: "Security & Stability Resilience Patch",
    description: "Emergency security and stability milestone hardening the platform architecture against runtime exceptions and schema conflicts.",
    points: [
      "Secured Public Changelog endpoints with architectural Optional Chaining.",
      "Resolved critical 500 SYSTEM_CRASH on paginated security history views.",
      "Performed platform-wide schema-integrity sweep across all historical nodes.",
      "Hardened UI rendering to gracefully handle legacy identity metadata.",
      "Synchronized System Backend security badges to the v2.5.8 baseline."
    ],
    category: "Security",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.5.7",
    date: "27 March 2026",
    title: "Admin Changelog Emergency Recovery",
    description: "Critical architectural fix resolving runtime exceptions through schema normalization and defensive rendering.",
    points: [
      "Normalized historical changelog schema (Renamed legacy 'changes' to 'points').",
      "Implemented architectural Optional Chaining in AdminChangelog.jsx.",
      "Resolved 500 SYSTEM_CRASH on the administrative evolution portal.",
      "Synchronized local data state with System Backend database nodes.",
      "Hardened UI resilience against malformed or legacy data records."
    ],
    category: "System Integrity",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.5.6",
    date: "27 March 2026",
    title: "Universal Suspension Enforcement",
    description: "Strict platform-wide protocol for deactivating restricted identities across public and 3rd-party endpoints.",
    points: [
      "Implemented real-time status audits in PublicProfile logic.",
      "Added 'Restriction Splash' for blocked developer portfolios.",
      "Locked down Embed Widgets for suspended/banned accounts.",
      "Ensured Private Support (SUID) accessibility for resolution/appeals.",
      "Synchronized enforcement between User Context and Public Viewports."
    ],
    category: "Security",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.5.5",
    date: "27 March 2026",
    title: "Administrative Governance",
    description: "Introduction of the Governance audit layer and the high-fidelity Security Review portal.",
    points: [
      "Created dedicated 'GOVERNANCE' sidebar group for senior staff.",
      "Implemented AdminSecurityReview.jsx audit queue.",
      "Added risk-level assessment (Low to Critical) for system flags.",
      "Integrated moderation workflows (Dismiss/Escalate/Restrict).",
      "Styled with System Backend premium security-first aesthetics."
    ],
    category: "Administration",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.5.4",
    date: "27 March 2026",
    title: "Profile Data Synchronization",
    description: "Architectural sync ensuring Admin analytics and profile portals are directly bound to core User identities.",
    points: [
      "Redirected Admin Profile metrics to the centralized 'users' collection.",
      "Resolved 'No Profiles Found' error by synchronizing retrieval logic.",
      "Corrected field mapping for GitHub, LeetCode, and Codeforces handles.",
      "Implemented safe 'Disable Profile' action for administrators.",
      "Synchronized system-wide identity integrity for Governance audits."
    ],
    category: "Identity",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.5.3",
    date: "27 March 2026",
    title: "Case Tracking Evolution",
    description: "Milestone release introducing high-fidelity, visual 'Case Journey' tracking for all governance requests.",
    points: [
      "Visual 4-Milestone Timeline for every security case and ID migration.",
      "Interactive 'Detailed Tracker' modal with granular condition descriptions.",
      "Live Pulse activity signaling for active moderation audits.",
      "Embedded status-responsive narratives (Submitted -> Reviewing -> Processing -> Finalized).",
      "System transition animations for streamlined governance transparency."
    ],
    category: "Engagement",
    status: "Stable"
  },
  {
    type: 'success',
    version: "v2.5.2",
    date: "27 March 2026",
    title: "Governance & Tracking",
    description: "Milestone release introducing granular sitemap governance and real-time user-facing case tracking.",
    points: [
      "Dynamic Sitemap Governance with administrative visibility toggles.",
      "Real-time User Case Tracking system integrated into Master Dashboard.",
      "High-fidelity 'Active Case Monitor' for prioritized status awareness.",
      "Global Sitemap integration for enhanced platform transparency.",
      "System status badges for streamlined moderation audits."
    ],
    category: "Governance",
    status: "Stable"
  },
  {
    version: "v2.5.1",
    date: "Mar 26, 2026",
    title: "Admin Insights & Governance Refinement",
    description: "Case ID tracking for identity migrations, tiered cost model, and high-fidelity QR branding.",
    points: [
      "Case ID Tracking: Unique identifiers (CASE-XXXXX) for all ID migration requests.",
      "Tiered Cost Model: 1st ID change is free; subsequent changes require 20 AI Credits.",
      "Admin Sitemap: Centralized inventory of all platform routes for administrator audit.",
      "Branded QR v2: Centered platform identifier for professional profile sharing."
    ]
  },
  {
    version: "v2.5.0",
    date: "March 26, 2026",
    title: "Security, Identity & Engagement",
    description: "Multi-stage ID Migration governance, Scan-to-Earn rewards, and centralized FAQ portal.",
    points: [
      "Governed Identity Lifecycle: New managed Profile ID change workflow.",
      "Engagement Rewards: Points system for QR scans and referral milestones.",
      "Security Integrity: Login-gate restriction enforcement with SUID error.",
      "FAQ Portal: High-fidelity documentation for Purge and Danger Zone procedures."
    ]
  },
  {
    version: "v2.4.0",
    date: "March 26, 2026",
    type: "launch",
    title: "High-Fidelity Security Core Redesign",
    description: "A major aesthetic and UX milestone transforming the account restriction experience into a premium SaaS-inspired interface.",
    points: [
      "Stripe/GitHub Aesthetics: Implemented a centered glassmorphic card with ruby-red glowing borders and bold typography.",
      "Structured Information Blocks: Organized policy violations into clear 'Reason for Action' and 'Policy Violation' sections.",
      "Professional Action Tray: Added primary gradient buttons with smooth animations for appeals and logouts.",
      "Security Icon Mapping: Integrated professional shield and hourglass icons for real-time status visualization.",
      "Adaptive Transparency: Enhanced the help box to provide clearer guidance for account recovery and support contact."
    ]
  },
  {
    version: "v2.3.0",
    date: "March 26, 2026",
    type: "feature",
    title: "Fast-Track Moderation & Staff Tools",
    description: "Launched a major security and moderation milestone introducing high-fidelity tools for administrators and a theme-aware restricted dashboard.",
    points: [
      "Fast-Track Suspension System: Integrated a new suspension modal with professional templates for rapid moderation.",
      "Live Profile Preview: Moderators can now inspect a user's live public profile directly within the suspension workflow.",
      "Adaptive Restricted Dashboard: Redesigned the /suspended portal to support Light, Dark, and System modes seamlessly.",
      "Enhanced Transparency: Restricted users now see granular 'Reason for Action' details and official description boxes."
    ]
  },
  {
    version: "v2.2.0",
    date: "March 26, 2026",
    type: "improvement",
    title: "Universal Notification Overhaul",
    description: "A comprehensive synchronization of the platform's communication engine and visual color standards.",
    points: [
      "Standardized Color System: Centralized Info, Success, Warning, and Critical hex codes across the entire platform.",
      "Notification Template Audit: Restructured 100+ automated messages to follow professional communication standards.",
      "Platform Footprint Warning: Implemented proactive triggers to nudge users with zero linked developer accounts.",
      "AI Broadcast Sync: Integrated the new templates with the administrative 'AI Fast Work' assistant."
    ]
  },
  {
    version: "v1.8.2",
    date: "March 16, 2026",
    type: "fix",
    title: "Diagnostic & Banner Stability",
    description: "Resolved critical build issues and optimized the System Update Banner for dynamic version detection.",
    points: [
      "App Root Refactor: Fixed scoping exceptions to ensure the Error Boundary has authenticated context.",
      "Dynamic Versioning: Upgraded the Update Banner to automatically reset on every platform release.",
      "Lint Optimization: Eliminated redundant exports and improved code structure for production readiness."
    ]
  },
  {
    version: "v1.8.1",
    date: "March 16, 2026",
    type: "feature",
    title: "Centralized Error Logging System",
    description: "Launched a comprehensive diagnostic infrastructure to track and resolve platform failures in real-time.",
    points: [
      "Admin Error Monitor: Created a secure portal at /admin/errors for high-fidelity failure snapshots.",
      "Authenticated Tracking: Integrated SUID mapping to identify which users encounter specific errors.",
      "Global Error Boundary: Implemented a 'Vercel-style' recovery interface with ER500- tracking IDs.",
      "Automated 404 Reporting: Every 'Not Found' encounter is now instantly reported to the Admin portal."
    ]
  },
  {
    version: "v1.8.0",
    date: "March 16, 2026",
    type: "improvement",
    title: "Public Interface Modernization",
    description: "A comprehensive high-fidelity redesign of the site's public-facing layers, introducing a cohesive 'System Evolution' aesthetic.",
    points: [
      "System Backgrounds: Integrated animated blobs and glassmorphism across Home and About pages.",
      "Documentation Overhaul: Redesigned the doc portal with premium sidebar navigation and interactive search.",
      "Legal Clarity: Refreshed Privacy and Terms pages with modern typography and AI-focused data transparency.",
      "Form Aesthetics: standardized focus-glow effects and premium input controls for all public forms."
    ]
  },
  {
    version: "v1.7.3",
    date: "March 16, 2026",
    type: "fix",
    title: "Intelligent Banner Suppression",
    description: "Enhanced the System Update Banner with routing intelligence to maintain professional presentation on clean views.",
    points: [
      "Route-Based Suppression: Automatically hides the system update banner on /resume and /embed pages.",
      "Layout Integrity: Ensures the 'banner-active' shift is disabled on professional views for pixel-perfect presentation.",
      "Persistence Awareness: Maintained global acknowledgement states across all platform routes."
    ]
  },
  {
    version: "v1.7.2",
    date: "March 16, 2026",
    type: "security",
    title: "Verification Ecosystem & Custom Errors",
    description: "Launched a dedicated security verification portal and a professional custom error tracking system.",
    points: [
      "DevTracker Verification Portal: Created a secure certification destination for resume QR scans.",
      "Deterministic Hex IDs: Implemented cryptographically-inspired 'DVTR-0x...' verification hashes for profile IDs.",
      "Vercel-Style 404: Designed a minimalist, code-focused error portal for non-existent paths.",
      "Reliability Tracking: Integrated unique ER404-[HEX] tracking IDs for superior system debugging."
    ]
  },
  {
    version: "v1.7.1",
    date: "March 16, 2026",
    type: "feature",
    title: "Premium Resume Portfolio Redesign",
    description: "A major overhaul of the portfolio view into a high-fidelity, recruiter-ready professional document.",
    points: [
      "Two-Column Architecture: Implemented a professional split layout with high-contrast sidebars.",
      "Integrated Coding DNA: Displaying verified skill pills and statistics directly in the resume view.",
      "Certification Badges: Added interactive Profile ID badges and authenticity seals.",
      "High-Fidelity Printing: Optimized pixel-perfect PDF output for professional high-resolution exports."
    ]
  },
  {
    version: "v1.7.0",
    date: "March 15, 2026",
    type: "launch",
    title: "DevTracker AI & Responsive Navigation",
    description: "A major intelligence and usability milestone introducing rebranded AI features and fluid dashboard navigation.",
    points: [
      "DevTracker AI Rebranding: Transformed Antigravity AI into a unified platform intelligence suite.",
      "DevTracker Assistant: Launched a rebranded floating robot assistant for proactive platform guidance.",
      "Responsive Dashboard Tabs: Redeveloped tab navigation with smooth horizontal scrolling for all devices.",
      "Clean Embed Focus: Automatically hides AI and Notification UI on /embed and /resume routes for better integration.",
      "Platform Sentiment AI: Integrated sentiment analysis and growth forecasting into staff-facing portals.",
      "AI Developer Persona: Enhanced dashboard insights with dynamic stat-driven developer archetypes."
    ]
  },
  {
    version: "v1.6.0",
    date: "March 13, 2026",
    type: "feature",
    title: "Platform-Wide Theme System & Dashboard Redesign",
    description: "A comprehensive core update introducing global theming and a massive high-fidelity redesign of the user workspace.",
    points: [
      "Adaptive Theming Engine: Launched Light, Dark, and System Default modes across every platform page.",
      "High-Fidelity Dashboard: Completely overhauled the user dashboard with a premium, modular layout.",
      "Admin Sidebar Polish: Fixed critical scroll issues and added custom, glassmorphism-inspired scrollbars.",
      "Documentation Revitalization: Expanded the portal with new guide sections for Themes and Workspace navigation.",
      "Share Profile Refinement: Improved link truncation and added monospace typography to the profile sharing suite.",
      "Global Brand Consistency: Standardized documentation, static pages, and staff ports with semantic theme tokens."
    ]
  },
  {
    version: "v1.5.0",
    date: "March 13, 2026",
    type: "feature",
    title: "Multi-Tiered Notification System",
    description: "Introduced a proactive broadcasting system for administrators to target specific user roles with real-time alerts.",
    points: [
      "Proactive Broadcasting: Enabled staff to send messages to Everyone, Registered Users, Moderators, or Support.",
      "Global Notification Center: Implemented a reactive, floating UI that listens for new alerts in real-time.",
      "Visual Unread Indicators: Added dynamic red-dot cues to User/Admin avatars for prompt notification awareness.",
      "Centralized Logic Hook: Created a unified useNotifications hook for consistent state across the platform."
    ]
  },
  {
    version: "v1.4.1",
    date: "March 13, 2026",
    type: "fix",
    title: "Administrative UI Refinement",
    description: "A styling overhaul of the administrative portal to align with the DevTracker design system.",
    points: [
      "Glassmorphism Overhaul: Replaced legacy borders with premium semi-transparent surfaces in Admin ports.",
      "Redesigned Statistics Monitor: Improved API health cards with better visual hierarchy and responsive grids.",
      "Optimized Component Structure: Migrated inline styles to dedicated CSS modules for Admin views.",
      "Unified Audit Interface: Synchronized badge styling and hover effects across all management tables."
    ]
  },
  {
    version: "v1.4.0",
    date: "March 13, 2026",
    type: "feature",
    title: "Dynamic Changelog & Showcase Mode",
    description: "A milestone update introducing real-time platform management and an interactive showcase for new users.",
    points: [
      "Interactive Showcase Mode: Launched a high-fidelity demo at /dev/demo with mock stat injection.",
      "Dynamic Changelog Portal: Migrated platform history to Firebase with a full CRUD staff manager.",
      "Reactive Version Sync: Unified footer versioning using a dedicated real-time listener hook.",
      "Security Persistence: Hardened the changelog node with strict role-based write shields."
    ]
  },
  {
    version: "v1.3.3",
    date: "March 13, 2026",
    type: "fix",
    title: "Cross-Platform Version Sync",
    description: "Synchronized version tracking across the Public Site and Admin Panel.",
    points: [
      "Automated Admin Versioning: Removed legacy hardcoded strings in the staff portal.",
      "Centralized Source of Truth: Linked all footers to the master changelog controller.",
      "Real-time Updates: Version changes now reflect globally across all authenticated views instantly."
    ]
  },
  {
    version: "v1.3.2",
    date: "March 13, 2026",
    type: "security",
    title: "Security Hardening (Phase 2)",
    description: "A critical security update to harden administrative access and database integrity.",
    points: [
      "Secured Admin Registration: Moved staff onboarding behind a strict Superadmin guard.",
      "Field-Level Protection: Implemented database rules to prevent unauthorized self-promotion to Admin.",
      "Staff Approval Workflow: Required manual authorization for all new administrative staff accounts.",
      "Data Node Isolation: Enforced strict read/write blocks on sensitive reports and statistics data."
    ]
  },
  {
    version: "v1.3.1",
    date: "March 13, 2026",
    type: "feature",
    title: "User Feedback & Account Transparency",
    description: "Launched the Integrated Reporting System and enhanced account restriction transparency.",
    points: [
      "Integrated a professional User Reporting & Appeals portal for feedback and complaints.",
      "Added Case Tracking IDs and a tracking dashboard in the Security tab.",
      "implemented 'Restricted State' tracking, allowing suspended users to monitor their appeals.",
      "Secured support reports by integrating Private Support IDs (SUID) into administrative views."
    ]
  },
  {
    version: "v1.3.0",
    date: "March 13, 2026",
    type: "feature",
    title: "Admin Suite & Security Hardening",
    description: "A major update focused on administrative infrastructure, professional branding tools, and platform security enforcement.",
    points: [
      "Created a secure, private Admin Documentation portal for internal handbooks.",
      "Implemented Professional Resume Generation for user profiles with export-ready styling.",
      "Launched Real-time API Health Monitoring with automated hourly diagnostics.",
      "Integrated Live API Traffic distribution charts in the Admin Statistics monitor.",
      "Redesigned the Admin Sidebar with a new collapsible 'Icons Only' desktop state.",
      "Enforced Account Suspension logic with real-time forced logout for banned users.",
      "Added QR Code generation to the User Dashboard for easier profile sharing."
    ]
  },
  {
    version: "v1.2.0",
    date: "March 13, 2026",
    type: "feature",
    title: "DevTracker Design Overhaul",
    description: "A massive front-end redesign bringing DevTracker up to modern SaaS standards. All pages now utilize high-fidelity glassmorphism, responsive grids, and unified styling.",
    points: [
      "Completely rebuilt the Landing Page with hero animations.",
      "Redesigned the entire Documentation system with ScrollSpy TOCs.",
      "Overhauled About, Contact, Privacy, and Terms into a shared static UI.",
      "Added Light/Dark Theme selection capabilities to the Embed Widgets."
    ]
  },
  {
    version: "v1.1.0",
    date: "March 12, 2026",
    type: "feature",
    title: "Realtime Database Migration & Changelog",
    description: "Migrated the entire backend infrastructure from Cloud Firestore to Firebase Realtime Database for improved sync performance. Also added this dedicated Changelog page to track platform updates.",
    points: [
      "Swapped firestore module in firebaseConfig.js for database module.",
      "Refactored Register, Dashboard, and AuthContext to use Realtime DB refs.",
      "Re-wrote public profile querying using orderByChild filtering.",
      "Added Changelog page."
    ]
  },
  {
    version: "v1.0.1",
    date: "March 05, 2026",
    type: "bugfix",
    title: "DOM Autocomplete Warnings Fixed",
    description: "Resolved browser warnings in the developer console related to missing autocomplete attributes on authentication forms.",
    points: [
      "Added autoComplete='username' and 'current-password' to Login.",
      "Added autoComplete='name', 'email', and 'new-password' to Register."
    ]
  },
  {
    version: "v1.0.0",
    date: "January 1, 2026",
    type: "launch",
    title: "DevTracker Initial Release",
    description: "The first stable public release of the DevTracker application.",
    points: [
      "User registration and Authentication flows.",
      "Dashboard integration with GitHub, LeetCode, Codeforces, and GeeksforGeeks.",
      "Live stats glassmorphism cards.",
      "Public portfolio routing (/dev/:id).",
      "Embeddable iframe widgets (/embed/:id)."
    ]
  }
];

// Helper to grab the most recent version string for the footer
export const getLatestVersion = () => {
  if (changelogUpdates.length > 0) {
    return changelogUpdates[0].version;
  }
  return "v1.0.0";
};

// Hook for dynamic versioning across the app
export const useLatestVersion = () => {
  const [version, setVersion] = useState(getLatestVersion());
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname.startsWith('/admin')) {
      setVersion('v4.3.1');
      return;
    }

    const logsRef = ref(db, 'changelog');
    const unsubscribe = onValue(logsRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const versions = Object.values(data).map(v => v.version);
        // Include local hardcoded version as a fallback/latest source
        versions.push(getLatestVersion());
        versions.sort((a, b) => b.localeCompare(a, undefined, { numeric: true, sensitivity: 'base' }));
        if (versions[0]) setVersion(versions[0]);
      }
    }, (error) => {
      console.error("Firebase read error on changelog version:", error);
    });

    return () => unsubscribe();
  }, [location.pathname]);

  return version;
};
